export const CARRIER_MATCHING_CHANGE_TRACKING = {
  carrierMatchingAddCarrier: {
    source: 'carrier_matching.add_carrier',
    id: 12410,
  },
  carrierMatchingRemoveCarrier: {
    source: 'carrier_matching.remove_carrier',
    id: 12411,
  },
  carrierMatchingEnterNewTruck: {
    source: 'carrier_matching.enter_new_truck',
    id: 12412,
  },
  carrierMatchingAddUser: {
    source: 'carrier_matching.add_user',
    id: 12413,
  },
} as const;
